import { takeLatest, call, put } from 'redux-saga/effects';
import {
  GET_DEPOSIT_QR_CODE_STRING,
  GET_DEPOSIT_QR_CODE_STRING_ERROR,
  SET_DEPOSIT_QR_CODE_STRING,
} from '../redux/action/types';
import { areaApi } from '../utils/api';

function* getDepositQrCodeString(action) {
  try {
    let response = yield call(() => areaApi.getDepositQrCodeString(action.data.data));
    yield put({ type: SET_DEPOSIT_QR_CODE_STRING, payload: response.data.data });
  } catch (error) {
    console.log('getDepositQrCodeString', error);
    yield put({
      type: GET_DEPOSIT_QR_CODE_STRING_ERROR,
    });
  }
}

function* depositsSaga() {
  yield takeLatest(GET_DEPOSIT_QR_CODE_STRING, getDepositQrCodeString);
}

export default depositsSaga;
